module.exports = __webpack_public_path__ + "img/gbwhatsapp-hero.3c769aa8.webp";